import React, { useState } from "react";
import { FC } from "react";
import { Button, Container, Form, Navbar } from "react-bootstrap";
import { Category, categoryImgs } from "../types/Category";
import { useCreateMissionMutation } from "../mutators/mission-mutator";
import { Mission } from "../types/Mission";
import { useNavigate } from "react-router-dom";
import { generateGUID } from "../util/Guid";

export const CreateMissionForm: FC = () => {
    const nav = useNavigate()
    const [selectedCatgory, setSelectedCatgory] = useState<Category>('Health');
    const [isRepeatable, setIsRepeatable] = useState(false);
    const createMissionMutation = useCreateMissionMutation()

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const title = (e.currentTarget.elements.namedItem('title') as HTMLInputElement).value
        const description = (e.currentTarget.elements.namedItem('description') as HTMLTextAreaElement).value
        const reward = Number((e.currentTarget.elements.namedItem('reward') as HTMLInputElement).value)
        const category = selectedCatgory
        const repeatable = (e.currentTarget.elements.namedItem('repeatable') as HTMLInputElement).checked
        const valStr = (e.currentTarget.elements.namedItem('streakExpiration') as HTMLInputElement)?.value
        const streakExpiration = isRepeatable && valStr !== "" ? Number(valStr) : undefined

        const mission: Mission = { id: generateGUID(), title, description, reward, category, repeatable, streakExpiration }

        await createMissionMutation.mutateAsync(mission)
        nav('/missions')
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Create Mission</h2>
                </Container>
            </Navbar>
            <Container>
                <form onSubmit={onSubmit}>
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label fs-4">Name</label>
                        <input type="text" className="form-control" id="title" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="description" className="form-label fs-4">Description</label>
                        <textarea className="form-control" id="description" rows={3}></textarea>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="reward" className="form-label fs-4">Reward</label>
                        <input type="number" className="form-control" id="reward" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="category" className="form-label fs-4">Category</label>
                        <div className="d-flex align-items-center">
                            <img src={categoryImgs[selectedCatgory]} alt={selectedCatgory} style={{ width: "20px", marginRight: "8px" }} />
                            <select className="form-select" id="category" value={selectedCatgory} onChange={(e) => setSelectedCatgory(e.target.value as Category)}>
                                {["Health", "Finance", "Education", "Social", "Ideology", "Feelings"].map((category) => (
                                    <option key={category} value={category}>
                                        {category}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Form.Check // prettier-ignore
                            onChange={(e) => setIsRepeatable(e.target.checked)}
                            className="mb-3 text-start"
                            type="switch"
                            id="repeatable"
                            label="Repeatable"
                        />
                    </div>
                    {isRepeatable && (
                        <div className="mb-3">
                            <label htmlFor="streakExpiration" className="form-label fs-4">Streak Expiration (days)</label>
                            <label htmlFor="streakExpiration" className="form-label fs-6">Leave empty for no streak modus</label>
                            <input type="number" className="form-control" id="streakExpiration" />
                        </div>
                    )}
                    <Button type="submit" className="w-100">Create Mission</Button>
                </form>
            </Container>
        </>
    )
}